export const features = [
  {
    id: 'lead-generation',
    title: 'Automatisierte Leadgenerierung',
    tooltip: 'Intelligente Lead-Erfassung mit automatischer Vorqualifizierung und Scoring',
    description: 'Erfassen Sie Leads automatisch über optimierte Formulare und qualifizieren Sie diese durch intelligente Fragelogik. Mit Supabase-Integration werden alle Daten sicher gespeichert und in Echtzeit ausgewertet. Automatisches Lead-Scoring priorisiert die vielversprechendsten Kontakte. Webhooks ermöglichen die nahtlose Integration in bestehende Systeme. Über API-Integrationen wie Google Places und Hunter können potenzielle Leads gezielt nach Ort, Branche und Zielgruppen gesucht, analysiert und automatisch in Ihre Pipeline importiert werden.',
    mockupType: 'table'
  },
  {
    id: 'chatbot-voice',
    title: 'Chatbot & Voice',
    tooltip: 'KI-Chatbot mit Sprach- und Textfunktion für 24/7 Kundenservice',
    description: 'Integrieren Sie einen intelligenten KI-Chatbot mit Voice-Funktion direkt in Ihre Website. Der Readdy Agent beantwortet Kundenanfragen rund um die Uhr, qualifiziert Leads vor und kann Termine direkt über Calendly buchen. Hybridmodus ermöglicht sowohl Text- als auch Sprachkommunikation. Perfekt für Support, Vertrieb und Terminvereinbarungen.',
    mockupType: 'chatbot'
  },
  {
    id: 'landing-funnel',
    title: 'Landingpages & Funnels',
    tooltip: 'Conversion-optimierte Landingpages und mehrstufige Funnel-Systeme',
    description: 'Erstellen Sie hochkonvertierende Landingpages und mehrstufige Funnel-Systeme mit integrierten Formularen, Stripe-Zahlungen und automatischer Lead-Weiterleitung. Perfekt für Produktlaunches, Webinare und Kampagnen. A/B-Testing und Conversion-Tracking inklusive. Calendly-Integration für automatische Terminbuchungen.',
    mockupType: 'editor'
  },
  {
    id: 'crm-system',
    title: 'CRM-System',
    tooltip: 'Vollständiges CRM mit Pipeline-Management und Aktivitäts-Tracking',
    description: 'Verwalten Sie Ihre gesamte Sales-Pipeline mit Supabase-Backend. Tracken Sie Deals, Aktivitäten und Kundeninteraktionen in Echtzeit. Multi-User-fähig mit Rollen- und Rechteverwaltung. Automatische Erinnerungen und Follow-up-Workflows. Integration mit Stripe für Zahlungsabwicklung direkt aus dem CRM.',
    mockupType: 'kanban'
  },
  {
    id: 'multi-user',
    title: 'Multi-User fähig',
    tooltip: 'Team-Kollaboration mit Rollen- und Rechteverwaltung',
    description: 'Arbeiten Sie im Team mit differenzierten Zugriffsrechten. Supabase Authentication ermöglicht sichere User-Verwaltung, Rollen-Zuweisung und Team-Kollaboration in Echtzeit. Definieren Sie individuelle Berechtigungen für verschiedene Abteilungen und Hierarchieebenen. SSO-Integration möglich.',
    mockupType: 'charts'
  },
  {
    id: 'academy',
    title: 'Schulungen & Akademie',
    tooltip: 'Integrierte Lernplattform für Anwender und Partner',
    description: 'Bieten Sie strukturierte Schulungen und Kurse direkt in Ihrer Plattform an. Mit Video-Integration, Fortschritts-Tracking und Zertifizierungen. Ideal für Partner-Onboarding und Kundenschulungen. Stripe-Integration für kostenpflichtige Kurse und Abonnements. Automatische Zertifikats-Generierung.',
    mockupType: 'academy'
  },
  {
    id: 'ai-content',
    title: 'KI Content-Generierung',
    tooltip: 'KI-gestützte Social Media Content-Erstellung mit Templates',
    description: 'Generieren Sie professionelle Social Media Posts mit KI-Unterstützung. Nutzen Sie Vorlagen für verschiedene Plattformen und planen Sie Content im Voraus. Integration mit OpenAI API für intelligente Texterstellung. Automatische Anpassung an Plattform-spezifische Anforderungen und Tonalität.',
    mockupType: 'social'
  },
  {
    id: 'calendar-booking',
    title: 'Terminbuchung & Kalender',
    tooltip: 'Automatische Terminvereinbarungen mit Calendly-Integration',
    description: 'Ermöglichen Sie Ihren Kunden die direkte Terminbuchung über Ihre Website. Calendly-Integration synchronisiert automatisch mit Ihrem Kalender und verhindert Doppelbuchungen. Automatische Erinnerungen per E-Mail und SMS. Perfekt für Beratungsgespräche, Demos und Service-Termine. Zeitzonenautomatik für internationale Kunden.',
    mockupType: 'calendar'
  },
  {
    id: 'payment-subscriptions',
    title: 'Zahlungen & Abonnements',
    tooltip: 'Stripe-Integration für einmalige und wiederkehrende Zahlungen',
    description: 'Wickeln Sie Zahlungen sicher über Stripe ab. Unterstützt einmalige Käufe, Abonnements und flexible Preismodelle. Automatische Rechnungserstellung und Dunning-Management für fehlgeschlagene Zahlungen. Ideal für SaaS-Produkte, Mitgliedschaften und digitale Produkte. PCI-DSS-konform und SEPA-fähig.',
    mockupType: 'payment'
  },
  {
    id: 'ecommerce',
    title: 'E-Commerce & Produktverkauf',
    tooltip: 'Shopify-Integration für Online-Shop-Funktionalität',
    description: 'Verkaufen Sie physische und digitale Produkte direkt über Ihre Website. Shopify-Integration bietet vollständiges Produktmanagement, Lagerbestandsverwaltung und Bestellabwicklung. Multi-Channel-Verkauf über verschiedene Plattformen. Automatische Versandbenachrichtigungen und Tracking. Perfekt für Produktverkauf und Merchandise.',
    mockupType: 'shop'
  },
  {
    id: 'realtime-notifications',
    title: 'Echtzeit-Benachrichtigungen',
    tooltip: 'Live-Updates und Push-Notifications mit Supabase Realtime',
    description: 'Halten Sie Ihre Nutzer mit Echtzeit-Benachrichtigungen auf dem Laufenden. Supabase Realtime ermöglicht Live-Updates ohne Seitenneuladung. Push-Notifications für wichtige Events, neue Nachrichten oder Status-Änderungen. Perfekt für kollaborative Tools, Chat-Systeme und Dashboards. WebSocket-basiert für minimale Latenz.',
    mockupType: 'notifications'
  },
  {
    id: 'file-storage',
    title: 'Datei-Upload & Speicherung',
    tooltip: 'Sichere Dateiverwaltung mit Supabase Storage',
    description: 'Ermöglichen Sie Nutzern den Upload von Dokumenten, Bildern und Medien. Supabase Storage bietet sichere, skalierbare Dateispeicherung mit automatischer Bildoptimierung. Zugriffsrechte auf Dateiebene, automatische Backups und CDN-Auslieferung. Ideal für Dokumentenmanagement, Profilbilder und Media-Libraries. Unterstützt alle gängigen Dateiformate.',
    mockupType: 'storage'
  }
];

export const useCases = [
  {
    id: 1,
    icon: 'ri-stethoscope-line',
    title: 'Gesundheitswesen',
    description: 'Optimieren Sie Patientenverwaltung, Terminplanung und medizinische Dokumentation mit maßgeschneiderten Lösungen.',
    features: [
      'Digitale Patientenakten',
      'Terminmanagement-System',
      'Abrechnungsautomatisierung',
      'DSGVO-konforme Datenspeicherung'
    ]
  },
  {
    id: 2,
    icon: 'ri-home-4-line',
    title: 'Immobilien',
    description: 'Verwalten Sie Objekte, Leads und Kundenkommunikation effizient mit einer integrierten Immobilien-Plattform.',
    features: [
      'Objektverwaltung & Exposés',
      'Lead-Tracking & Besichtigungen',
      'Automatische Benachrichtigungen',
      'Vertragsmanagement'
    ]
  },
  {
    id: 3,
    icon: 'ri-shopping-cart-2-line',
    title: 'E-Commerce',
    description: 'Steigern Sie Ihren Online-Umsatz mit intelligenten Shop-Systemen, Inventory-Management und Marketing-Automation.',
    features: [
      'Multi-Channel-Verkauf',
      'Lagerbestandsverwaltung',
      'Personalisierte Empfehlungen',
      'Automatisiertes Marketing'
    ]
  },
  {
    id: 4,
    icon: 'ri-lightbulb-line',
    title: 'Beratung',
    description: 'Optimieren Sie Ihre Beratungsprozesse mit Tools für Projektmanagement, Zeiterfassung und Client-Kommunikation.',
    features: [
      'Projektmanagement-Tools',
      'Zeiterfassung & Abrechnung',
      'Client-Portal',
      'Wissensmanagement'
    ]
  }
];

export const technologies = [
  {
    id: 1,
    name: 'React',
    description: 'Moderne UI-Bibliothek für schnelle, interaktive Benutzeroberflächen',
    icon: 'ri-reactjs-line',
    color: '#61DAFB'
  },
  {
    id: 2,
    name: 'TypeScript',
    description: 'Typsicherer Code für robuste und wartbare Anwendungen',
    icon: 'ri-code-s-slash-line',
    color: '#3178C6'
  },
  {
    id: 3,
    name: 'Supabase',
    description: 'Open-Source Backend mit Echtzeit-Datenbank und Authentication',
    icon: 'ri-database-2-line',
    color: '#3ECF8E'
  },
  {
    id: 4,
    name: 'TailwindCSS',
    description: 'Utility-First CSS-Framework für schnelles, responsives Design',
    icon: 'ri-palette-line',
    color: '#06B6D4'
  },
  {
    id: 5,
    name: 'AI-Integration',
    description: 'KI-gestützte Automatisierung für intelligente Workflows',
    icon: 'ri-brain-line',
    color: '#14B8A6'
  }
];
